import { render, staticRenderFns } from "./authorizationCookies.vue?vue&type=template&id=35058b05&scoped=true"
import script from "./authorizationCookies.vue?vue&type=script&lang=js"
export * from "./authorizationCookies.vue?vue&type=script&lang=js"
import style0 from "./authorizationCookies.vue?vue&type=style&index=0&id=35058b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35058b05",
  null
  
)

export default component.exports